import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdaptemyApi, GetReportsContextInterface } from '../+api';
import { DAL_OPTIONS, DalOptions } from '../dal.module';
import {
  AdaptemyServiceInterface,
  SubConceptReportContextInterface,
  SubConceptReportsContextInterface,
  SubConceptReportsForConceptInterface,
} from './adaptemy.service.interface';

@Injectable({
  providedIn: 'root',
})
export class AdaptemyService implements AdaptemyServiceInterface {
  private httpClient = inject(HttpClient);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private AdaptemyApi = inject(AdaptemyApi);

  public getSubConceptResultsForGroup(
    groupId: number,
    context: SubConceptReportContextInterface
  ): Observable<SubConceptReportsForConceptInterface> {
    const { apiBaseUrl } = this.dalOptions;

    const url = `${apiBaseUrl}/api/adaptemy/sub-concept-results-for-group`;

    const params = new HttpParams({
      fromObject: {
        groupId,
        context: JSON.stringify(context || {}),
      },
    });

    return this.httpClient.get<SubConceptReportsForConceptInterface>(url, { params, withCredentials: true });
  }

  public getSubConceptResultsForClassGroup(
    classGroupId: number,
    context: SubConceptReportContextInterface
  ): Observable<SubConceptReportsForConceptInterface> {
    const { apiBaseUrl } = this.dalOptions;

    const url = `${apiBaseUrl}/api/adaptemy/sub-concept-results-for-class-group`;

    const params = new HttpParams({
      fromObject: {
        classGroupId,
        context: JSON.stringify(context || {}),
      },
    });

    return this.httpClient.get<SubConceptReportsForConceptInterface>(url, { params, withCredentials: true });
  }

  public getSubConceptResultsForContext(
    context: SubConceptReportsContextInterface
  ): Observable<SubConceptReportsForConceptInterface[]> {
    const { apiBaseUrl } = this.dalOptions;

    const url = `${apiBaseUrl}/api/adaptemy/sub-concept-results-for-context`;

    const params = new HttpParams({
      fromObject: {
        context: JSON.stringify(context || {}),
      },
    });

    return this.httpClient.get<SubConceptReportsForConceptInterface[]>(url, { params, withCredentials: true });
  }

  public getReportsForClassGroup(classGroupId: number, context: GetReportsContextInterface) {
    return this.AdaptemyApi.getReportsForClassGroup(classGroupId, context);
  }

  public getReportsForGroup(groupId: number, context: GetReportsContextInterface) {
    return this.AdaptemyApi.getReportsForGroup(groupId, context);
  }

  public getReportsForContext(context: GetReportsContextInterface) {
    return this.AdaptemyApi.getReportsForContext(context);
  }
}
